// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"1331455c","377":"3da061eb","700":"ae9d1ccc"}[chunkId] + ".chunk.js";
};